module.exports = __webpack_public_path__ + "img/Postmodernisme_Trude-Marstein.8aa91c5d.jpg";